import { render, staticRenderFns } from "./LeavePlanReviewerList.vue?vue&type=template&id=0c8695b8&scoped=true"
import script from "./LeavePlanReviewerList.vue?vue&type=script&lang=js"
export * from "./LeavePlanReviewerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8695b8",
  null
  
)

export default component.exports